import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import { useCartStore } from '@/features/cart';
import { Bullet, Icon } from '@/shared/ui';

interface CartToggleMobileProps {
  className?: string;
}

import styles from './cartToggleMobile.module.scss';

const CartToggleMobile: FC<CartToggleMobileProps> = (props) => {
  const { className } = props;
  const { totalCount } = useCartStore();
  return (
    <Link
      className={classNames(styles.toggle, className)}
      href="/cart"
      title="Корзина"
    >
      {totalCount === 0 ? (
        <Icon name="cartEmpty" />
      ) : (
        <Bullet count={totalCount} />
      )}
    </Link>
  );
};

export default CartToggleMobile;
